{
  "EMOJI": {
    "PLACEHOLDER": "Sök emoji",
    "NOT_FOUND": "Ingen emoji matchar din sökning",
    "REMOVE": "Radera"
  }
}
